import React, { Children, Component } from 'react';
import classlist from 'utils/classlist';
import './style.scss';

const isMobile = window.innerWidth < 540;

export interface IFormLayoutProps {
    layout: string; // layout="1:2"
    className?: string;
    noFlexInMobile?: boolean; // 支持不用flex布局
    children: React.ReactNode;
}

/**
 * @description
 * 主要用户表单横向多栏弹性布局，可以通过layout属性传递子节点的宽度比列划分
 * 例如：下面的例子即将两个子节点按照1比2的宽度占比进行分配：
 *
 * <FormLayout layout="1:2">
 *  ...
 * </FormLayout>
 */
class FormLayout extends Component<IFormLayoutProps> {
    static defaultProps = {
        layout: ''
    };

    public render() {
        const flexValues = this.props.layout.split(':');
        const noneNullChildren: any[] = [];
        const { className, noFlexInMobile } = this.props;

        Children.forEach(this.props.children, child => {
            if (child !== null) {
                noneNullChildren.push(child);
            }
        });

        return (
            <div className={classlist((noFlexInMobile && isMobile) || 'form-layout-root', className)}>
                {Children.map(noneNullChildren, (child: any, index) => {
                    return <div className={`form-layout-flex form-layout-flex-${flexValues[index] || 1}`}>{child}</div>;
                })}
            </div>
        );
    }
}

export default FormLayout;
